// extracted by mini-css-extract-plugin
module.exports = {"root":"render-option_root__1UgOs"};